import React from 'react';
import PropTypes from 'prop-types';
import { ButtonGroup, IconButton, InputAdornment } from '@mui/material';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faArrowDown, faArrowUp } from '@fortawesome/free-solid-svg-icons';
import TableControls from '../../../BaseEditor/tableControls';
import { metaFieldPropType } from '../hooks/metafields';
import { ListItem } from '../styles';

function MetaFieldItem({
  metaField, active, onRenameField, onClick,
  onMoveUp, onMoveDown, canUp, canDown,
}) {
  return (
    <ListItem
      active={active}
      style={{ marginTop: '4px' }}
      onClick={onClick}
    >
      <TableControls.StringInput
        controlId={`input-metafield-${metaField.itemKey}`}
        value={metaField.name}
        onChange={(e, v) => onRenameField(metaField.name, v)}
        startAdornment={(
          <InputAdornment position="start">
            {metaField.sort || '!'}
          </InputAdornment>
        )}
        endAdornment={(
          <InputAdornment position="end">
            <ButtonGroup>
              <IconButton onClick={onMoveUp} disabled={!canUp}>
                <FontAwesomeIcon icon={faArrowUp} />
              </IconButton>
              <IconButton onClick={onMoveDown} disabled={!canDown}>
                <FontAwesomeIcon icon={faArrowDown} />
              </IconButton>
            </ButtonGroup>
          </InputAdornment>
        )}
      />
    </ListItem>
  );
}

MetaFieldItem.propTypes = {
  metaField: metaFieldPropType.isRequired,
  active: PropTypes.bool,
  onRenameField: PropTypes.func.isRequired,
  onClick: PropTypes.func.isRequired,
  onMoveUp: PropTypes.func.isRequired,
  onMoveDown: PropTypes.func.isRequired,
  canUp: PropTypes.bool,
  canDown: PropTypes.bool,
};

MetaFieldItem.defaultProps = {
  active: false,
  canUp: false,
  canDown: false,
};

export default MetaFieldItem;
